export class Dealer {
    constructor() {
        this.id = 0,
        this.identifier = null,
        this.details = {}
    }
}

export class Payload {
    constructor(endpoint, method, payload) {
        this.endpoint = endpoint
        this.method = method, // GET, POST, PUT, DELETE
        this.payload = payload || {}
        this.headers = []
    }
    withCredentials(key, value) {
        this.headers.push({ key, value})
    }
}

export class Control {
    constructor() {
            this.sellerIdentifier = null,
            this.status = null,
            this.startDate = null,
            this.endDate = null,
            this.user = null
    }
}